<template>
  <div class="stepped-progress d-flex py-md-2 w-100">
    <div class="d-none d-lg-flex h-full text-left align-items-center flex-grow-1" v-if="displayIntroText">
      <span class="text-normal font-bold text-secondary items-baseline text-baseline">{{ $t('steps.hintTexts.' + this.steps.filter(item => item.state === 'active')[0]['key'], [this.plugSide])}}</span>
    </div>
    <!-- <div class="d-none flex-column justify-content-between mr-3">
      <button @click="$store.state.switchedLayout = false" class="btn btn-sm" :class="[$store.state.switchedLayout === false ? 'btn-dark' : 'btn-light']">altes Layout</button>
      <button @click="$store.state.switchedLayout = true" class="btn btn-sm" :class="[$store.state.switchedLayout === true ? 'btn-dark' : 'btn-light']">neues Layout</button>
    </div>
    <div class="d-flex flex-column justify-content-between">
      <button @click="$i18n.locale = 'de'" class="btn btn-sm" :class="[$i18n.locale === 'de' ? 'btn-dark' : 'btn-light']">DE</button>
      <button @click="$i18n.locale = 'en'" class="btn btn-sm" :class="[$i18n.locale === 'en' ? 'btn-dark' : 'btn-light']">EN</button>
    </div> -->
    <div class="d-flex" v-for="(step, index) in steps" :key="`${index}-${step.label}`" >
      <stepped-progress-item :label="step.label" :caption="step.caption" :state="step.state" :first="index === 0" :last="index === steps.length - 1"/>
    </div>
  </div>
</template>

<script>
import SteppedProgressItem from './SteppedProgressItem'

export default {
  name: 'SteppedProgress',
  components: {
    SteppedProgressItem
  },
  props: {
    steps: { 
      type: Array, 
      default () {
        return [
          {id: 0, label: 1, caption: this.$t('steps.default.cable'), state: `active`, key: 'cable'},
          {id: 1, label: 2, caption: this.$t('steps.default.plugs'), state: `unconfigured`, key: 'plugs'},
          {id: 2, label: 3, caption: this.$t('steps.default.options'), state: `unconfigured`, key: 'options'},
          {id: 3, label: '<i class="fas fa-check"></i class>', caption: `${ this.$t('steps.default.done') } `, state: `unconfigured`, key: 'done'},
        ]
      }
    },
    plugSide: {
      type: String,
      default: 'A + B'
    },
    displayIntroText: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.bg-darkgrey {
  background-color: $darker-eee;
}

.text-darkgrey {
  color: $darker-eee;
}

@media (max-width: 768px) {
  .stepped-progress {
    font-size: .8em;
  }
}
</style>
